import $ from 'jquery';
import 'slick-carousel';

const initTabs = () =>   {

  // let tabTriggers = document.querySelectorAll('.floorplantabTrigger');
  // let tabContents = document.querySelectorAll('.floorplans__container');

  // Array.prototype.forEach.call(tabTriggers, (trigger) => {

  //   trigger.addEventListener('click', (e) => {

  //     document.querySelector('.floorplans__headingIcon--active').classList.remove('floorplans__headingIcon--active');
  //     document.querySelector('.floorplans__container--active').classList.remove('floorplans__container--active');

  //     e.preventDefault();

  //     let clickedTabNumber = trigger.attributes.tabnumber.value;

  //     trigger.classList.add('floorplans__headingIcon--active');

  //     Array.prototype.forEach.call(tabTriggers, (tab) => {

  //       let tabNumber = tab.attributes.tabnumber.value;
  //       if (clickedTabNumber === tabNumber)
  //       tab.classList.add('floorplans__headingIcon--active');
  //     });

  //     Array.prototype.forEach.call(tabContents, (tab) => {

  //       let tabNumber = tab.attributes.tabnumber.value;

  //       if (clickedTabNumber === tabNumber)
  //         tab.classList.add('floorplans__container--active');
  //     })

  //   });

  // });

  const slideCount = document.querySelectorAll('.floorplans__headingIcon').length;

  $('.floorplan-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite:true,
    arrows:true,
    asNavFor: '.floorplans__tabs'
  });
  $('.floorplans__tabs').slick({
    slidesToShow: slideCount,
    slidesToScroll: 1,
    asNavFor: '.floorplan-slider',
    dots: false,
    centerMode: false,
    focusOnSelect: true
  });

  let tabMessureTriggers = document.querySelectorAll('.messureTrigger');
  let tabMessureContents = document.querySelectorAll('.floorplan-row');

  Array.prototype.forEach.call(tabMessureTriggers, (trigger) => {

    trigger.addEventListener('click', (e) => {

      document.querySelector('.floorplans__type-link--active').classList.remove('floorplans__type-link--active');
      let FloorplanRow = document.querySelectorAll('.floorplan-row--active');

      Array.prototype.forEach.call(FloorplanRow, (trigger) => {
        trigger.classList.remove('floorplan-row--active');
      })

      e.preventDefault();

      let clickedTabNumber = trigger.attributes.tabnumber.value;

      trigger.classList.add('floorplans__type-link--active');


      Array.prototype.forEach.call(tabMessureContents, (tab) => {

        let tabNumber = tab.attributes.tabnumber.value;

        if (clickedTabNumber === tabNumber)
          tab.classList.add('floorplan-row--active');
      })

    });

  });

}


function FloorplanTabs () {
  initTabs();
}

export default FloorplanTabs;